export default {"src":"/_next/static/media/drone_64.674f78b6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};